<template>
  <div class="container">
    <!-- 导航菜单栏 -->
    <nav-bar />
    <!-- 头部区域 -->
    <head-bar />
    <!-- 主内容区域 -->
    <main-content />
  </div>
</template>

<script>
import HeadBar from "./HeadBar/HeadBar";
import NavBar from "./NavBar/NavBar";
import MainContent from "./MainContent/MainContent";
export default {
  components: {
    HeadBar,
    NavBar,
    MainContent
  }
};
</script>

<style scoped lang="scss">
  .container {
    position:absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    // background: rgba(224, 234, 235, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue